function modifySearchBox() {
  const searchInput = $('.searchBoxInput .inputFieldTextbox');
  if (searchInput.length) {
    searchInput.val('Search');
    searchInput.focus(() => {
      if (searchInput.val() === 'Search') {
        searchInput.val('');
      }
    });
    searchInput.blur(() => {
      if (searchInput.val() === '') {
        searchInput.val('Search');
      }
    });
  }
}

function ticketCharacterLimit() {
  let $ticketLink = $('.ticket');
  let text = $ticketLink.text();
  if (text.length > 7) {
    $ticketLink.text(text.substring(0, 7));
  }

  setTimeout(function () {
    $('.ticket').css('display', 'flex');

    // Call the function to limit text length
    ticketCharacterLimit();
  }, 100); // 2000 milliseconds = 2 seconds
}

function featureText() {
  let $featureText = $('.featureLineup-text');
  let $featureTextInset = $('span.featureLineup-headline.button');
  let text = $featureText.text();
  if (text.length > 150) {
    text = text.substring(0, 150) + '...';
    $featureText.text(text);
  }
  if (text.length > 40) {
    text = text.substring(0, 44) + '...';
    $featureTextInset.text(text);
  }
}

function modifyEmailBox() {
  const searchInput = $('.emailSignup .emailInputField');
  if (searchInput.length) {
    searchInput.val('Enter Email');
    searchInput.focus(() => {
      if (searchInput.val() === 'Enter Email') {
        searchInput.val('');
      }
    });
    searchInput.blur(() => {
      if (searchInput.val() === '') {
        searchInput.val('Enter Email');
      }
    });
  }
}

function modifyFooterInputText() {
  const emailInput = $('.emailSignup input');
  const emailSubmitLink = $('.emailInputSubmit a');
  if (emailInput.length) {
    emailInput.attr('value', 'Email Address');
  }
  if (emailSubmitLink.length) {
    emailSubmitLink.text('Sign Up');
  }
  emailInput.focus(() => {
    emailInput.val('');
  });
  emailInput.on('input', () => {
    console.log('Input value changed to:', emailInput.val());
  });
}

$(document).ready(function () {
  modifySearchBox();
  modifyFooterInputText();
  modifyEmailBox();
  ticketCharacterLimit();
  featureText();

  // General Message
  $('.generalmessage').prependTo('.header');
});
window.onload = function () {
  ticketCharacterLimit();
};
$(window).on('load', function () {
  // Set a timer to delay the display change
  setTimeout(function () {
    $('#siteInfoBannerWidget').css('opacity', '1');
  }, 1000); // Delay in milliseconds (2000ms = 2 seconds)
});
